<template>
  <div class="home h-100">
    <!-- Navigation -->
    <PostCareerNavbar />
    <section class="hero-header">
      <div class="container">
            <div class="row back-wrapper">
              <div class="col-12">
                <div class="backBtn-wrapper">
                  <a @click="$router.push({ name: 'Careers'})" href="#" class="btn">
                    <span class="fas fa-arrow-left"></span>
                    <span class="ml-2 back">Back to Careers</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="blog-post-wrapper">
              <div class="overlay"></div>
              <picture>
                <source media="(max-width: 400px)" srcset="/img/careers-expanded-image-mobile.png">
                <source media="(min-width: 768px)" srcset="/img/careers-expanded-image.svg">
                <img src="/img/careers-expanded-image.svg" alt="" class="img-fluid">
              </picture>
             
            </div>
        </div>
    </section>

    <!-- developer -->
    <section class="developer">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="developer-wrap">
              <h2>Direct Sales Representative</h2>
              <p>Fulltime | Lagos</p>
            </div>
          </div>
          <div class="col-md-6"></div>
        </div>
      </div>
    </section>

    <!-- Description -->
    <section class="description">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <div class="description-wrap">
              <h3>Job Description</h3>
            </div>
          </div>
          <div class="col-md-8">
            <div class="description-text">
              <p>Direct Sales Representative will introduce company products to potential customers and close sales.</p>
              <p>Direct Sales Representative’s will research competing products, identify opportunities to increase sales, and assist in the development and execution of sales and marketing plans</p>
              <p>Direct Sales will answer customers’ questions regarding product pricing, availability, features, and benefits.</p>
              <p>Direct Sales Representative is expected to achieve exceptional customer service and ensure that purchased products are delivered to customers in a timely manner.</p>
              <p>Direct Sales Representatives will demonstrate strong negotiation skills and convince customers to purchase company products.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Responsibility -->
    <section class="description">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <div class="description-wrap">
              <h3>Your Responsibility</h3>
            </div>
          </div>
          <div class="col-md-8">
            <div class="description-text">
             <ul>
               <li>Meet or exceed weekly, monthly, and yearly sales quotas.</li>
               <li>Canvass assigned territories to present company products to potential customers.</li>
               <li>Assist management in identifying viable marketing and pricing strategies</li>
               <li>Demonstrate product features to customers.</li>
               <li>Contact leads and setting up appointments to present company products.</li>
               <li>Attend trade shows and other industry-related events.</li>
               <li>Prepare sales proposals for potential buyers.</li>
               <li>Complete regular sales reports specifying the number of sales made.</li>
             </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Requirements -->
    <section class="description requirement">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <div class="description-wrap">
              <h3>Requirements</h3>
            </div>
          </div>
          <div class="col-md-8">
            <div class="description-text">
             <ul>
               <li>First Degree from a recognized tertiary Institution.</li>
               <li>Proven experience in Sales & Marketing.</li>
               <li>The ability to retain important information.</li>
               <li>Sound consultative selling skills.</li>
               <li>Excellent networking skills.</li>
               <li>Strong negotiation skills.</li>
               <li>Effective communication skills.</li>
               <li>Exceptional customer service skills.</li>
             </ul>
            </div>
            <div class="cv-wrap">
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSdz5g87AKWvHW7YYPjobQCny-n63XGW2R4SUxvqb4iCtifD-Q/viewform" class="btn btn-primary px-5 py-2" target="_blank">Appy Now</a>
            </div>
            
          </div>
        </div>
      </div>
    </section>
    
    <Footer />
  </div>
</template>

<script>
import Footer from "../components/Footer"
import PostCareerNavbar from "../components/PostCareerNavbar.vue";

export default {
  name: 'Home',
  components: {
    PostCareerNavbar,
    Footer
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/variables/colors.scss";

  // hero header styles
  .hero-header {
      padding-top: 6rem;

      .blog-post-wrapper {
          margin-top: 1rem;
          position: relative;

          .overlay {
            position: absolute;
            width: 100%;
            height: 100%;
            background: linear-gradient(180deg, #2B3990 0%, #94248C 100%);
            mix-blend-mode: multiply;
            opacity: 0.85;
            border-radius: 8px;
          }
      }

      .back {
        font-family: Source Sans Pro;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 20px;
        color: #2C3C90;
      }
  }

  // developer styles
  .developer {
    padding: 2rem 0 4rem;

    .developer-wrap {
      background: #2C3C90;
      border-radius: 4px;
      color: #fff;
      padding: 3.5rem 1.5rem;
      margin-top: -7rem;
      margin-left: -2rem;

      h2 {
        font-weight: bold;
        font-size: 40px;
        line-height: 50px;
        letter-spacing: 0.02em;
      }

      p {
        font-family: 'Poppins', sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 36px;
      }
    }
  }

  h3 {
    font-weight: bold;
    font-size: 25px;
    line-height: 48px;
    letter-spacing: 0.02em;
    color: #2C3C90;
  }



  // description
  .description { 
      margin-bottom: 2rem;

      p, ul {
        font-family: Poppins;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.02em;
        color: #0D0D26;
      }

      ul {
        padding-left: 20px;
      }
  }

  .requirement {
    margin-bottom: 6rem;

    .btn {
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      margin-top: 1rem;
    }
  }
     

  @media (min-width: 992px) and (max-width: 1199px) {
    .hero-header {
      padding-top: 6rem;
    }

    .developer {

      .developer-wrap {

        h2 {
          font-size: 32px;
          line-height: 40px;
        }

        p {
          font-size: 18px;
        }
      }
    }

    h3 {
      font-size: 23px;
    }

  }


  @media (min-width: 767px) and (max-width: 991px) {
    .hero-header {
      padding-top: 6rem;
    }

    .developer {

      .developer-wrap {

        h2 {
          font-size: 25px;
          line-height: 32px;
        }

        p {
          font-size: 16px;
        }
      }
    }

    h3 {
      font-size: 18px;
    }

  }

  @media (max-width: 767px) {
    .hero-header {
      padding-top: 6rem;
    }

    .developer {
      padding: 2rem 0 2rem;

      .developer-wrap {
        margin-top: 0;
        margin-left: 0;

        h2 {
          font-size: 28px;
          line-height: 40px;
        }

      }
    }

    h3 {
      font-size: 20px;
    }

    .cv-wrap {
      display: flex;
      justify-content: center;
    }
  }

  @media (max-width: 575px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");
        padding-top: 6rem;

        .description {

            h1 {
                line-height: 46px;
            }

        }
    }

    // .who-we-are {
    //   position: relative;
    //   .who-we-are-img-wrapper {
        
        
    //     img {
    //       position: absolute;
    //       right: -3rem;
    //       top: 0;
    //     }
    //   }
    // }

    
  }

  @media (max-width: 375px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");

        .description {

            h1 {
                font-size: 35px;
            }

            p {
                font-size: 17px;
                padding: 0 2rem;
            }
        }
    }

    
  }


</style>

